var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"primary","large":"","block":"","elevation":"14"},on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.btnText)+" ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }